module.exports = __webpack_public_path__ + "0c27d7717e390811d972f3122ab82dbf.jpg";